module.exports = __webpack_public_path__ + "img/background.9857be65.png";